export default "__VITE_ASSET__BocMRl_a__"